import axios from 'axios';
import { config } from '../apiConfig';

const AgencyProfile = async (method, parameters, conf) => {
    let result = '';
    if (conf) {
        let response = await axios.post(`${config.url}/api/mvc/AgencyProfile/${method}`, parameters, conf)
            .then(function (response) {
                return response;
            }).catch(function (error) {
                return error.response.data;
            });
        if (response.status === 200) {

            result = {
                status: 'success',
                data: response
            };
        } else {
            result = {
                status: 'faild',
                data: response
            };
        }
        return result;
    } else {
        let response = await axios.post(`${config.url}/api/mvc/AgencyProfile/${method}`, parameters)
            .then(function (response) {
                return response;
            }).catch(function (error) {
                return error.response.data;
            });

        if (response.status === 200) {
            result = {
                status: 'success',
                data: response
            };
        } else {
            result = {
                status: 'faild',
                data: response
            };
        }
        return result;
    }

}

export default AgencyProfile;